// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-timer\"> <i class=\"fa fa-clock-o\"></i> <!-- ko text: _labels.TIMER --><!-- /ko --> </a>";
// Exports
export default code;